import {
  Localizations
} from 'localize'

Localizations.append({
  modules: {
    cart: {
      components: {
        shoppingCart: {
          title: 'Your cart',
          continueShopping: 'Continue shopping',
          proceed: 'Proceed to checkout',
          error: 'We couldn\'t load your shopping cart. Please refresh the page and try again.',
          cartEmpty: 'Cart Empty'
        }
      }
    }
  }
})
